import { render, staticRenderFns } from "./QnAModerationCheckBox.vue?vue&type=template&id=68f73dcc&scoped=true&"
import script from "./QnAModerationCheckBox.vue?vue&type=script&lang=js&"
export * from "./QnAModerationCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./QnAModerationCheckBox.vue?vue&type=style&index=0&id=68f73dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f73dcc",
  null
  
)

export default component.exports